import { useCallback } from 'react';
import {
  AIEditSection,
  CHART_CONFIG,
} from 'components/Wizards/shared/components/AIEditSection';
import useShouldExpandModal from '../../hooks/useShouldExpandModal';

const buildConfigFromState = (state) => {
  if (!state?.reportType?.value) return null;

  return {
    report_type: state.reportType?.value,
    metric_type: state.value?.value || state.metric,
    field: state.field?.value,
    frequency: state.datapointFrequency?.value,
    historical: state.compare ?? false,
    name: state.name || '',
  };
};

const ChartAIEditSection = ({
  inModal,
  autoOpen = false,
  currentDashboard,
  homepage,
  isEditing,
  selectedObjectId,
  setSelectedObjectId,
}) => {
  const willModalExpand = useShouldExpandModal(
    selectedObjectId,
    currentDashboard
  );

  const handleSuccess = useCallback(
    (generatedConfig) => {
      setSelectedObjectId(generatedConfig.custom_object);
    },
    [setSelectedObjectId]
  );

  return (
    <AIEditSection
      inModal={inModal}
      autoOpen={autoOpen}
      isEditing={isEditing}
      homepage={homepage}
      buildConfigFromState={buildConfigFromState}
      willModalExpand={willModalExpand}
      entityConfig={CHART_CONFIG}
      dashboardId={currentDashboard?.id}
      targetObjectId={selectedObjectId}
      onSuccessCallback={handleSuccess}
      oneShotOnly
    />
  );
};

export default ChartAIEditSection;
